import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";

import { Modal, TextAreaProps } from "semantic-ui-react";

import moment from "moment";

import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import SearchBoxWithKey from "react-lib/appcon/common/SearchBoxWithKey";

import SnackMessage from "react-lib/apps/common/SnackMessage";

import ModSearchDoctorNote from "react-lib/apps/APP/ModSearchDoctorNote";

import ModMakeAppointmentRehabUX from "./ModMakeAppointmentRehabUX";

import {
  RehabDeviceSlotType,
  RehabPlanType,
  SelectRehabDeviceSlotType,
} from "./RHBInterface";

import { formatDate, getOrdinal } from "react-lib/utils/dateUtils";

type ModMakeAppointmentRehabProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  proxyController: any;
  checkedAppointmentList?: Record<string, any>[];
  divisionId: any;
  open: boolean;
  rehabDeviceSlot?: RehabDeviceSlotType;
  rehabTreatmentList?: RehabPlanType[];
  selectedDevices: Record<string, any>[];
  selectedRehabDeviceSlot?: SelectRehabDeviceSlotType;
  buttonLoadCheck: any;
  errorMessage: any;
  languageUX: "en" | "th";
  searchedItemListWithKey: any;
  selectedPatient: any;
  onClose: () => void;
  onSuccess: (data: { appointment: any }) => void;
};

const BUTTON_ACTIONS = {
  save: "SAVE",
};

const MOD_MAKE_APPOINTMENT_REHAB = "ModMakeAppointmentRehab";

const ACTION_SAVE = `${MOD_MAKE_APPOINTMENT_REHAB}_${BUTTON_ACTIONS.save}`;

const ModMakeAppointmentRehab = (props: ModMakeAppointmentRehabProps) => {
  const [openModDoctorNote, setOpenModDoctorNote] = useState<boolean>(false);
  const [doctorNote, setDoctorNote] = useState("");
  const [physiotherapist, setPhysiotherapist] = useState<number | null>(null);

  useEffect(() => {
    if (props.open) {
      setDoctorNote(props.selectedRehabDeviceSlot?.order_note || "");
      setPhysiotherapist(props.selectedRehabDeviceSlot?.physiotherapist ?? null);
    }
  }, [props.open]);

  const deviceList = useMemo(
    () =>
      props.selectedDevices.map((device) => {
        const devices = props.rehabDeviceSlot?.devices ?? [];
        const foundItem = devices.find((item) => item.id === device.device);

        return {
          ...device,
          end_datetime: device.end_datetime,
          name: foundItem?.name || "",
          start_datetime: device.start_datetime,
        };
      }),
    [props.rehabDeviceSlot, props.selectedDevices]
  );

  const appointmentList = useMemo(
    () =>
      props.selectedRehabDeviceSlot?.order_id
        ? props.selectedRehabDeviceSlot.items
        : props.checkedAppointmentList,
    [props.checkedAppointmentList, props.selectedRehabDeviceSlot]
  );

  const rehabNameList = useMemo(
    () =>
      (appointmentList ?? []).map((item, index) => {
        const flatItems = (props.rehabTreatmentList ?? []).flatMap((acc) => acc.items);
        const foundItem = flatItems.find((acc) => acc.id === item.plan_item);
        const ordinal = getOrdinal(item.no);

        return (
          <div key={`rehab-name-${index}`}>
            <strong>
              {ordinal.number}
              <sup>{ordinal.suffix}</sup> {foundItem?.name || ""}
            </strong>
          </div>
        );
      }),
    [appointmentList, props.rehabTreatmentList]
  );

  const handleAddNote = () => {
    setOpenModDoctorNote(true);
  };

  const handleOnSelectNote = (noteList: string[]) => {
    const formattedNote = noteList.map((note) => `- ${note}`);

    const note: (number | string)[] = doctorNote ? [doctorNote, ...formattedNote] : formattedNote;

    setDoctorNote(note.join("\n"));
  };

  const handleChangeDoctorNote = (e: SyntheticEvent, data: TextAreaProps) => {
    setDoctorNote(String(data.value));
  };

  const handleSave = () => {
    props.onEvent({
      message: "makeAppointmentRhbTreatment",
      params: {
        btnAction: ACTION_SAVE,
        devices: props.selectedDevices,
        division: props.divisionId,
        items: appointmentList,
        order_note: doctorNote,
        physiotherapist,
        onSuccess: props.onSuccess,
      },
    });
  };

  console.log("ModMakeAppointmentRehab props:", props);

  return (
    <>
      <SnackMessage
        error={props.errorMessage?.[ACTION_SAVE]}
        success={null}
        onClose={() => {
          props.setProp(`errorMessage.${ACTION_SAVE}`, null);
        }}
      />

      <Modal
        style={{ minWidth: "50rem", width: "max-content" }}
        open={props.open}
        closeOnDimmerClick
        onClose={props.onClose}
      >
        <ModMakeAppointmentRehabUX
          appointmentDate={formatDate(moment(props.selectedDevices[0]?.start_datetime))}
          patientInfo={props.selectedPatient}
          rehabNameList={rehabNameList}
          remark={doctorNote}
          languageUX={props.languageUX}
          onAddNote={handleAddNote}
          onChangeDoctorNote={handleChangeDoctorNote}
          onClose={props.onClose}
          buttonMakeAppointment={
            <ButtonLoadCheck
              setProp={props.setProp}
              color="green"
              // disabled={!!props.selectedRehabDeviceSlot?.order_id}
              paramKey={ACTION_SAVE}
              size="small"
              title="Make appointment"
              buttonLoadCheck={props.buttonLoadCheck?.[ACTION_SAVE]}
              onClick={handleSave}
            />
          }
          deviceList={
            deviceList.length === 0 ? (
              "-"
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto max-content auto 1fr",
                  lineHeight: "1.75",
                  marginLeft: "0.5rem",
                }}
              >
                {deviceList.map((item, index) => (
                  <React.Fragment key={`medication-${index}`}>
                    <div
                      style={{
                        backgroundColor: "rgba(0,0,0,.87)",
                        borderRadius: "500rem",
                        height: "4px",
                        margin: "auto",
                        width: "4px",
                      }}
                    />
                    <label style={{ padding: "0 5rem 0 0.5rem" }}>{item.name}</label>
                    <label style={{ paddingRight: "3rem" }}>Time</label>
                    <label>
                      {moment(item.start_datetime).format("HH:mm")} -{" "}
                      {moment(item.end_datetime).format("HH:mm")}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            )
          }
          physiotherapistSearchBox={
            <SearchBoxWithKey
              onEvent={props.onEvent}
              id="MAR"
              defaultText={props.selectedRehabDeviceSlot?.physiotherapist_fullname}
              dropdownStyle={{ width: "29rem" }}
              placeholder="Unspecified"
              role="TECHNICIAN_PMR"
              selectedItem={physiotherapist}
              size="small"
              type="User"
              inline
              searchedItemListWithKey={props.searchedItemListWithKey}
              setSelected={(value) => {
                setPhysiotherapist(value);
              }}
            />
          }
        />
      </Modal>

      <Modal
        open={openModDoctorNote}
        onClose={() => {
          setOpenModDoctorNote(false);
        }}
      >
        <ModSearchDoctorNote
          controller={props.proxyController}
          division={props.divisionId}
          onClose={() => {
            setOpenModDoctorNote(false);
          }}
          onSelectNote={handleOnSelectNote}
        />
      </Modal>
    </>
  );
};

ModMakeAppointmentRehab.displayName = "ModMakeAppointmentRehab";

export default React.memo(ModMakeAppointmentRehab);
